import CustomButton from "atoms/customButton/CustomButton";
import React from "react";
import styles from "./ShowApiKey.module.scss";
import { Info } from "lucide-react";

interface ShowApiKeyProps {
	heading: string;
	apiKey: string;
	handleShowModal: () => void;
	handleCopy: () => void;
  subheading:string
}

const ShowApiKey = ({ heading, apiKey, handleShowModal, handleCopy,subheading }: ShowApiKeyProps) => {
	return (
		<div className={`${styles.showApiKey}`}>
			<h2>{heading}</h2>
            <div className="flex gap-2 bg-[#f2f2f2] p-4 my-2 rounded-lg">
			<Info /><p>{subheading}</p>
            </div>
			{/* <p>This is your new API key. Make sure to copy it before closing this dialog as it won &apos;t be displayed again!</p> */}
			<div className={`${styles.showApiKey__input}`}>
				<input readOnly value={apiKey} />
			</div>
			<div className={`flex justify-end ${styles.showApiKey__button}`}>
				<CustomButton className="outline sm" buttonText="Close" handleFunc={handleShowModal} />
				<CustomButton className="sm" id="copy-button" buttonText="Copy to Clipboard" handleFunc={handleCopy} />
			</div>
		</div>
	);
};

export default ShowApiKey;
